import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class CreditsPartIIIService {
  constructor(private http: HttpClient) {}

  saveCreditForms(
    baseUrl: string,
    clobData: any,
    clobSettings: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject?action_code=mvxxgb';
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(clobData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);
    params.process_name = 'credit-forms-grid-save';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
